import { render } from "./RedZonesActionsButtons.vue?vue&type=template&id=00f40d80"
import script from "./RedZonesActionsButtons.vue?vue&type=script&lang=js"
export * from "./RedZonesActionsButtons.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__